<template lang="html">


    <div class="container-fluid">
        <div v-if="overlay == true"
             id="cargando"
             wire:loading
             class="
          fixed
          top-0
          left-0
          right-0
          bottom-0
          w-full
          h-screen
          z-50
          overflow-hidden
          bg-gray-700
          opacity-75
          flex flex-col
          items-center
          justify-center
        ">
            <div class="
            loader
            ease-linear
            rounded-full
            border-4 border-t-4
            h-12
            w-12
            mb-4
          "></div>
            <h2 class="text-center text-white text-xl font-semibold">
                Cargando...
            </h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>

        <v-row>
            <v-col lg=12 cols=12 style="margin: 0 auto;">
                <v-card>
                    <v-card-title class="pa-5 pb-3 primary">
                        <!--<v-icon class="pr-4" :color="'#FFFFFF'">mdi-file-document</v-icon>-->
                        <p style="color: white;">Confirmación de Documentos Ausa</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="pa-5 pt-4">
                        <v-row>
                            <v-col md="8" offset-md="2">
                                <!--<vs-list>
                                <v-row justify="end">
                                    <v-col md="auto">
                                        <span style="color: black;">Documentos Ausa</span>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col md="auto">
                                        <span>SI</span>
                                    </v-col>
                                    <v-col md="auto" class="mr-5">
                                        <span>NO</span>
                                    </v-col>
                                </v-row>
                            </vs-list>
                            <v-divider></v-divider>-->




                                <v-list-item>
                                    <v-list-item-content>
                                        <span style="color: black;font-size:15px">Selecciona Si o No dependiendo si el asegurado cuenta con los documentos o se van a Gestionar por Ausa</span>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <vs-list>
                                            <v-row justify="center" align-content="center">
                                                <v-col class="px-3">
                                                    <span>SI</span>
                                                </v-col>
                                                <v-col class="px-4">
                                                    <span>NO</span>
                                                </v-col>
                                            </v-row>
                                        </vs-list>
                                    </v-list-item-action>
                                </v-list-item>
                                <!--<v-divider></v-divider>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Factura
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <vs-list>
                                        <v-row justify="center" align-content="center">
                                            <v-col class="px-2">
                                                <v-checkbox></v-checkbox>
                                            </v-col>
                                            <v-col class="px-2">
                                                <v-checkbox></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </vs-list>
                                </v-list-item-action>
                            </v-list-item>-->
                                <!--<span style="color: black; text-align: center;">Documentos:</span>
                            <span style="color: black; text-align: center;">Factura </span>
                            <v-checkbox></v-checkbox>
                            <v-checkbox></v-checkbox>-->

                                
                                <v-form ref="form"
                                        v-model="valid"
                                        lazy-validation>
                                    <div v-for="(item, index) in documentos" :key="index">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{item.dodescrip}}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <vs-list>
                                                    <v-row justify="center" align-content="center">
                                                        <v-radio-group v-model="item.valueradio"
                                                                       :rules="[v => !!v || 'Campo requerido']"
                                                                       required
                                                                       :readonly="item.valdigital"
                                                                       row>

                                                            <v-radio @change="changeradio()" value="1"></v-radio>

                                                            <v-radio @change="changeradio()" value="0"></v-radio>

                                                        </v-radio-group>
                                                    </v-row>
                                                </vs-list>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-divider></v-divider>
                                    </div>
                                </v-form>
                                <v-list-item >
                                    <v-list-item-content v-if="!valid">
                                        <span class='spanError' style='color:red;font-size:11px'>Debe validar todos los documentos</span>
                                    </v-list-item-content>
                                    <v-list-item-content v-if="validaIguales">
                                        <span class='spanError' style='color:red;font-size:11px'>Debe modificar al menos un registro</span>
                                    </v-list-item-content>
                                </v-list-item>


                            </v-col>
                        </v-row>
                        <div v-if="!disabledradios">
                            <v-row justify="center" class="mb-8">
                                <v-btn class="ma-2"
                                       color="primary"
                                       @click="Guardar()"
                                       :disabled="disabledSave">
                                    Guardar
                                </v-btn>
                                <!--<v-btn class="ma-2"
                                   @click="limpiarCampos()"
                                   :disabled="disabledSave">
                                Limpiar
                            </v-btn>-->

                            </v-row>
                        </div>
                        <div class="mt-10"><br></div>




                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>
    </div>

    <!--</v-container>-->

</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import seguimiento from '@/services/Seguimiento/seguimiento.service.js';
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    export default {
        props: {
            
        },
        data() {
            return {
                nrreporte: '',
                svindice: '',
                aiclave: '',
                documentos: [],
                documentosresp:[],
                disabledSave: true,
                valid: true,
                disabledradios: false,
                validaIguales: false,
                validaConclusion: false,
                overlay: true
            }
        },
        computed: {
            ...mapGetters(['getUser', 'THEME_STATE']),
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage', 'permission']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            }
        },
        methods: {
            changeradio() {
                this.validaIguales = false;
            },
            //Guardar1() {
            //    this.documentos.forEach((value, index) => {

            //        console.log(this.documentos[index].valueradio);
            //        console.log(this.documentosresp[index].valueradio);

            //        if (this.documentos[index].valueradio == this.documentosresp[index].valueradio) {
            //            console.log('es igual');
            //        }
            //    });
            //},
            Guardar() {
                var count = 0;
                this.disabledSave = true;
                if (this.$refs.form.validate()) {

                    this.documentos.forEach((value, index) => {

                        if (this.documentos[index].valueradio != this.documentosresp[index].valueradio) {
                            count++;
                        }
                    });
                    if (count > 0) {
                        //this.disabledSave = true;
                        this.$swal({
                            position: 'center',
                            title: 'Guardando información, espere un momento....',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            didOpen: () => {
                                this.$swal.showLoading();
                            }
                        });

                        seguimiento.guardarValidacionDocumentosAusa(this).then(response => {

                            setTimeout(() => {

                                
                                this.documentos = [];
                                this.documentosresp = [];
                                if (response) {

                                    seguimiento.obtenerDocumentosAusa(this).then(response1 => {
                                        seguimiento.obtenerDocumentosAusa(this).then(response2 => {
                                            this.documentos = response1;
                                            this.documentosresp = response2;
                                            this.$swal.close();
                                            this.$swal({
                                                position: 'center',
                                                icon: 'success',
                                                title: 'Éxito',
                                                text: 'Se guardó con éxito.',
                                                showConfirmButton: true,
                                                timer: 3000
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    this.disabledSave = false;
                                                }
                                            });
                                            setTimeout(() => {
                                                this.disabledSave = false;
                                            }, 3000);
                                        });

                                    });



                                }
                                else {
                                    this.$swal({
                                        position: 'center',
                                        icon: 'error',
                                        title: 'Error',
                                        text: 'Hubo un error, comuníquese con el área de Sistemas',
                                        showConfirmButton: true,
                                        allowOutsideClick: false,
                                        allowEscapeKey: false
                                    })
                                }

                            }, 2000);




                        });
                    }
                    else {
                        this.disabledSave = false;
                        this.validaIguales = true;
                    }
                }
                else {
                    this.disabledSave = false;
                }
            },
            limpiarCampos() {
                this.documentos.forEach((value, index) => {
                    this.documentos[index].valueradio = '';
                });
                this.validaIguales = false;
                this.$refs.form.reset();
            }
        },
        async mounted() {
            this.validaConclusion = await MetodosGenerales.getReporteEstatus(this);  //true si esta abierto
            //let datos = JSON.parse(sessionStorage.getItem('reporte'));
            let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
            this.nrreporte = datos.nrreporte;
            this.svindice = datos.svindice;
            this.aiclave = datos.aiclave;

            seguimiento.obtenerDocumentosAusa(this).then(response => {
                seguimiento.obtenerDocumentosAusa(this).then(response1 => {

                    seguimiento.validarEdicion(this).then(response2 => {
                        if (response2 != 1 || !this.validaConclusion) {
                            this.disabledradios = true;
                        }
                        this.documentos = response;
                        this.documentosresp = response1;
                        this.disabledSave = false;
                        this.overlay = false;

                    });

                });

            });
        }
    }

</script>
